module.exports = __webpack_public_path__ + "img/special1.32381584.png";